module.exports = __webpack_public_path__ + "static/media/bCross.c5ae21ea.svg";